<template>
    <ion-nav ref="costumerModalNav" :root="CostumerForm" :rootParams="data"></ion-nav>
</template>

<script setup lang="ts">
import {IonNav} from "@ionic/vue";
import CostumerForm from "@/components/modals/CostumerForm.vue";
import {computed, markRaw, onMounted, PropType, provide, ref} from "vue";
import {ICostumer} from "@/types/costumer";

const props = defineProps({
    costumer: {
        type: Object as PropType<ICostumer>,
        required: false,
    },
})

const data = computed(() => {
    if (props.costumer) {
        return markRaw({
            costumer: markRaw(props.costumer as Object)
        });
    } else {
        return undefined
    }
});
const costumerModalNav = ref<InstanceType<typeof IonNav> | null>(null)
onMounted(() => {
})

provide('navController', costumerModalNav)

</script>
